// extracted by mini-css-extract-plugin
export default {"input":"M8-z","button":"N8-z","selected":"O8-z","unavailable":"P8-z","oos":"Q8-z","image":"R8-z","paperCutDisabledOverlay":"S8-z"};